export default from './MonthlyBudget';



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/components/MonthlyBudget/index.js